(function($) {
    'use strict';

    var $banner = $('#team-gallery-banner');
    if (!$banner.length) return;

    var $slides = $banner.find('.team-gallery-slide');
    var $dots = $banner.find('.team-gallery-dot');
    var total = $slides.length;
    var current = 0;
    var interval = null;

    function goTo(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;

        $slides.removeClass('active');
        $dots.removeClass('active');
        $slides.eq(index).addClass('active');
        $dots.eq(index).addClass('active');
        current = index;
    }

    function startAutoPlay() {
        interval = setInterval(function() {
            goTo(current + 1);
        }, 5000);
    }

    function stopAutoPlay() {
        clearInterval(interval);
    }

    $banner.find('.team-gallery-prev').on('click', function() {
        stopAutoPlay();
        goTo(current - 1);
        startAutoPlay();
    });

    $banner.find('.team-gallery-next').on('click', function() {
        stopAutoPlay();
        goTo(current + 1);
        startAutoPlay();
    });

    $dots.on('click', function() {
        stopAutoPlay();
        goTo($(this).data('index'));
        startAutoPlay();
    });

    if (total > 1) {
        startAutoPlay();
    }

})(jQuery);
